// extracted by mini-css-extract-plugin
export default {"externalPaymentMethodWrapper":"XrEg5JCo72cSKFpoMX9H","snapPaypalButton":"AUk6_v0D80cSCQI8xf99"};